import StudentCreate from "@/controllers/student/student-create";
import axios from "axios";
import { maxLength, minValue, required } from "vuelidate/lib/validators";
import { withParams } from "vuelidate/lib";
import ValidationService from "@/services/ValidationService";
import store from "@/store";

const inZoneOptions = withParams(
  { type: "inZoneOptions" },
  function (value) {
    if (value === 0 || value === null || value === "" || typeof value === "undefined") {
      return true;
    }

    return this.zoneArr.some((zone) => Number(zone.id) === Number(value));
  }
);

export default {
  extends: StudentCreate,
  mixins: [ValidationService],
  data() {
    return {
      academicYearArr: [],
      selectAcdYear: 0,
      student_no: "",
      referredByStudentNo: "",
      referrerInfo: null,
      referrerLookupError: "",
      zoneArr: [{
        id: 0,
        text: "Select Zone"
      }],
      selectedZone: 0,
    };
  },

  validations: {
    ...StudentCreate.validations,
    student_no: {
      required
    },
    selectAcdYear: {
      required,
      minValue: minValue(1)
    },

    referredByStudentNo: {
      maxLength: maxLength(20),
    },
    selectedZone: {
      inZoneOptions,
    }
  },

  watch: {
    selectAcdYear(acdYearId) {
      this.gradeArr = [];
      this.selectedGrade = this.grade = 0;
      this.getGradeName(acdYearId);
      this.generateStudentNumber(acdYearId);
    },

    selectedGrade(gradeId) {
      this.noSectionMsg = '';
      this.grade = gradeId;
      this.selectedSection = this.section = 0;
      this.sectionArr = [];

      var request = {
        params: {
          campus_id: this.$store.state.user.campus_id,
          academic_year: this.selectAcdYear,
        }
      }

      this.getSection(gradeId, request);
    },
      
    selectedSection(sectionId) {
      this.section = sectionId;
      this.section_exist = '';
    }
  },

  computed: {
    referredByError() {
      return this.validationErrors.referred_by_student_no?.[0]
        || this.referrerLookupError
        || "";
    },
  },

  methods: {
    lookupReferrer() {
      const studentNo = this.referredByStudentNo.trim();

      this.referrerInfo = null;
      this.referrerLookupError = "";

      if (!studentNo) {
        if (this.validationErrors.referred_by_student_no) {
          this.validationErrors.referred_by_student_no = [];
        }
        return;
      }

      axios
        .get(`student/getReferrerStudentName/${studentNo}`, {
        })
        .then((res) => {
          if (!res.data?.data) {
            this.referrerInfo = null;
            this.referrerLookupError = "Unable to find referrer student.";
            return;
          }
          this.referrerInfo = res.data;
          if (this.validationErrors.referred_by_student_no) {
            this.validationErrors.referred_by_student_no = [];
          }
        })
        .catch((error) => {
          this.referrerInfo = null;
          if (this.validationErrors.referred_by_student_no) {
            this.validationErrors.referred_by_student_no = [];
          }
          this.referrerLookupError =
            error.response?.data?.message || "Unable to find referrer student."
        });
    },

    getAcademicYears() {
      axios
        .get("period/periodList")
        .then((res) => {
          this.academicYearArr = res.data.data;
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status == 401) {
              this.$store.commit("logout");
              window.location.replace("login");
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },

    getZones() {
      axios
        .get("ferry-zone/list")
        .then((res) => {
          const options = res.data.map((zone) => ({
            id: zone.id,
            text: `${zone.zone_name} (${zone.ferry_price})`
          }));
          this.zoneArr = [{
            id: 0,
            text: "Select Zone"
          }].concat(options);
        })
        .catch((err) => {
          if (err.response && err.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
        });
    },

    generateStudentNumber(acdYearId) {
      if (!acdYearId) {
        this.student_no = "";
        return;
      }
      axios
        .get("/student/generate-student-number/" + acdYearId)
        .then((res) => {
          this.student_no = res.data.student_no || "";
        })
        .catch((error) => {
          console.log("Error generating student number", error);
          this.student_no = "";
        });
    },

    register() {
      this.disabled = true;
      this.validationErrors = {};
      const request = {
        parent_id: this.parentData.id,
        name: this.studentData.name,
        student_image: this.student_image,
        entry_no: this.entry_no,
        referred_by_student_no: this.referredByStudentNo,
        dob: this.studentData.dob,
        gender: this.studentData.gender,
        nationality: this.studentData.nationality,
        grade: this.grade,
        religion: this.religion,
        section: this.section,
        weight: this.studentData.weight,
        blood: this.studentData.blood,
        height: this.studentData.height,
        phone1: this.studentData.phone1,
        phone2: this.studentData.phone2,
        sibling: this.studentData.sibling,
        hobby: this.studentData.hobby,
        allergic_food: this.studentData.allergic_food,
        previous_school: this.studentData.previous_school,
        special_topic: this.studentData.special_topic,
        zone_id: Number(this.selectedZone) || null,
        campus_id: this.$store.state.user.campus_id,
        created_id: this.$store.state.user.id,
      };

      axios.post("/student/create", request, {
        headers: {
          "Content-Type": "application/json",
        }
      })
        .then(response => {
          if (response.status == 204) {
            this.submitted = false;
            this.getSection(this.grade, {
              params: {
                campus_id: this.$store.state.user.campus_id
              }
            });
            this.disabled = false;
            this.section_exist = "Section doesn't exist. Please choose other section.";
            return;
          }
          if (response.data.success == true) {
            this.$notification.success("Student Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "studentList"
            });
          } else {
            this.disabled = false;
            this.$notification.error(response.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          this.printValidationError(error.response);

          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }

          this.isLoading = false;
          this.disabled = false;

          if (error.response.status == 422) {
            return;
          }

          this.$notification.error("Unable to create student. Please Try Again", {
              timer: 3,
              position: "bottomCenter"
            });
          console.log("Student Create API Error", error.errors);
        });
    },

    getGradeName(acdYearId) {
      if (!acdYearId) {
        this.gradeArr = [];
        return;
      }
      axios.get('getGradeNameByAcademicYear', {
        params: {
          id: acdYearId,
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        this.gradeArr = res.data;
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },
  },
  mounted() {
    this.isLoading = true;
    this.getAcademicYears();
    this.getZones();
  },
};
